import { Icon } from "@/components/Icon";

const CalculatorInfoLayer = () => {
  return (
    <div className=" mt-8 bg-blue-light font-medium flex justify-center rounded-md p-6 text-white mb-8">
      <Icon type="info" className="w-8 h-8 mr-4 -mt-3" />
      Leider kann ihre Wunschrate gerade nicht berechnet werden. Sie können uns
      gerne über den Finanzierungsrechner eine Anfrage mit Ihren Spezifikationen
      stellen und wir werden mit einem individuellen Angebot auf Sie zukommen.
    </div>
  );
};

export default CalculatorInfoLayer;
